module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "close-modal-btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n    X\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b17898c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/type/ModalCloseButton.vue
// module id = 1344
// module chunks = 2